import { useMemo, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { useSelector } from "react-redux";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { getExportItem } from "../../connections/getExportItem";
import { toast } from "react-toastify";
import JobStatusExportModal from "./JobStatusExportModal";
import dayjs from "dayjs";
import JobStatusTable from "./JobStatusTable";
import JobStatusExportTable from "./JobStatusExportTable";

const DataExport = () => {
  const {
    user: { user },
  } = useSelector((store) => store);

  // ✅ dayjs defaults (ISO string for input[type="date"])
  const defaultStart = useMemo(
    () => dayjs("2024-01-01").format("YYYY-MM-DD"),
    [],
  );
  const defaultEnd = useMemo(() => dayjs().format("YYYY-MM-DD"), []);

  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleExport = async () => {
    try {
      // ✅ validation
      if (dayjs(endDate).isBefore(dayjs(startDate), "day")) {
        toast.error("End date cannot be earlier than Start date.");
        return;
      }

      setLoading(true);

      const res = await getExportItem(
        user?.token,
        "download_request",
        startDate,
        endDate,
      );

      // if (res?.OK) {
      toast.success(`Request sent! Check Job Status. ID: ${res?.job_id}`);
      // } else {
      //   toast.error("Export request failed. Please try again.");
      // }
    } catch (error) {
      console.error("Export failed:", error);
      toast.error("Export failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Sidebar activeClassName="data-import" />

      <div>
        <div className="content container-fluid">
          <div className="card shadow-sm border-0">
            <div className="card-body">
              {/* ✅ Header Row */}
              <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between mb-3">
                <div>
                  <h4 className="mb-1 fw-semibold">
                    Export Invoice Items Report
                  </h4>
                  <small className="text-muted">
                    Select a date range to generate the invoice items CSV.
                  </small>
                </div>
                {/* 
                <button
                  className="btn btn-outline-primary px-3"
                  style={{ height: 40 }}
                  onClick={() => setShowModal(true)}
                >
                  <FeatherIcon icon="activity" size={16} className="me-2" />
                  Job Status
                </button> */}
              </div>

              {/* ✅ Form Row */}
              <div className="row g-3 align-items-end">
                <div className="col-12 col-md-4">
                  <label className="form-label fw-medium">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    max={endDate} // ✅ nice UX
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>

                <div className="col-12 col-md-4">
                  <label className="form-label fw-medium">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    min={startDate} // ✅ nice UX
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>

                <div className="col-12 col-md-4">
                  <button
                    className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                    style={{ height: 42 }}
                    onClick={handleExport}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        />
                        Exporting...
                      </>
                    ) : (
                      <>
                        <FeatherIcon
                          icon="download"
                          size={16}
                          className="me-2"
                        />
                        Export Report
                      </>
                    )}
                  </button>

                  <div className="mt-2 text-muted small">
                    Range:{" "}
                    <span className="fw-semibold">
                      {dayjs(startDate).format("DD MMM YYYY")}
                    </span>{" "}
                    →{" "}
                    <span className="fw-semibold">
                      {dayjs(endDate).format("DD MMM YYYY")}
                    </span>
                  </div>
                </div>
              </div>

              {/* Optional helper note */}
              <div className="alert alert-light border mt-4 mb-0">
                <FeatherIcon icon="info" size={16} className="me-2" />
                After exporting, open <b>Job Status</b> to check progress and
                download the file.
              </div>
            </div>
          </div>
        </div>
        {/* ✅ Job Status Table at bottom (no modal) */}
        <JobStatusExportTable token={user?.token} visible={true} />
        {/* <JobStatusExportModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          token={user?.token}
        /> */}
      </div>
    </>
  );
};

export default DataExport;
